module.exports = __webpack_public_path__ + "static/img/google-plus.2a96f509.png";